import React, { useMemo, useState } from "react";
import { Grid, MenuItem, TextField } from "@mui/material";
import { usePlatform } from "../platform/store";
import { DataTable, PageRoot, SectionCard, StatusChip, SummaryGrid } from "./ui/PlatformPrimitives";

const DocumentRepository = () => {
  const { documents, products, vendors } = usePlatform();
  const [typeFilter, setTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const rows = useMemo(
    () =>
      documents.filter((document) => {
        const typeMatch = !typeFilter || document.type === typeFilter;
        const statusMatch = !statusFilter || document.status === statusFilter;
        return typeMatch && statusMatch;
      }),
    [documents, statusFilter, typeFilter]
  );

  return (
    <PageRoot>
      <SummaryGrid
        items={[
          ["Documents", documents.length],
          ["Types", new Set(documents.map((document) => document.type)).size],
          ["Products", new Set(documents.map((document) => document.productId).filter(Boolean)).size],
          ["Vendors", new Set(documents.map((document) => document.vendorId).filter(Boolean)).size],
        ]}
      />

      <SectionCard eyebrow="Filters" title="Repository">
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 4 }}>
            <TextField fullWidth select label="Type" value={typeFilter} onChange={(event) => setTypeFilter(event.target.value)}>
              <MenuItem value="">All types</MenuItem>
              {Array.from(new Set(documents.map((document) => document.type))).map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <TextField fullWidth select label="Status" value={statusFilter} onChange={(event) => setStatusFilter(event.target.value)}>
              <MenuItem value="">All statuses</MenuItem>
              {Array.from(new Set(documents.map((document) => document.status))).map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </SectionCard>

      <SectionCard eyebrow="Index" title="Stored documents">
        <DataTable
          columns={[
            { key: "title", label: "Title" },
            { key: "type", label: "Type" },
            {
              key: "productId",
              label: "Product",
              render: (row) => products.find((product) => product.id === row.productId)?.name || "Unassigned",
            },
            {
              key: "vendorId",
              label: "Vendor",
              render: (row) => vendors.find((vendor) => vendor.id === row.vendorId)?.name || "Unassigned",
            },
            {
              key: "status",
              label: "Status",
              render: (row) => <StatusChip status={row.status} />,
            },
            {
              key: "uploadedAt",
              label: "Uploaded",
              render: (row) => new Date(row.uploadedAt).toLocaleDateString(),
            },
          ]}
          rows={rows}
          getRowKey={(row) => row.id}
        />
      </SectionCard>
    </PageRoot>
  );
};

export default DocumentRepository;
